<style lang="scss" scoped>
.class {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		display: flex;
		justify-content: space-between;
		@include flex-center;
		&__options {
			margin-left: auto;
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	&__details {
		&__container {
			padding-left: 1.5rem;
			padding-right: 1.5rem;
			margin-bottom: 1.5rem;
		}
		&__body {
			border-style: solid;
			border-width: 1px;
			border-radius: 0.375rem;
			padding-left: 1.5rem;
			padding-right: 1.5rem;
		}
	}
}
</style>
<template lang="pug">
.class__details__container
    .class__details__body
        h2 Details
        p Name: {{ selectedClass.name }}
        p Status: {{ selectedClass.courseState || 'N/A' }}
        p Owner{{ owner.length > 1 ? 's': '' }}: {{ owner ? owner.join(", ") : 'N/A' }}
</template>

<script>
export default {
	props: {
		selectedClass: Object,
		owner: Array,
	}
}
</script>